module.exports = __webpack_public_path__ + "img/Patiententransportgruppe.3b7f7a1a.svg";